import {cleanObject} from '~/default/scripts/utils/generic'

export const getRealEstateGUIDs = () => {
	const guids = {
		sale: 'a793ed2b-a9f8-4e6e-ae3b-b37c4d5bc609',
		rent: '095f8b48-2b6d-468a-8829-6b8aeba49935',
		touristRental: '070ef7fb-cda0-453f-ad19-8e9c52833e8f',
	}

	return guids
}

// @param contract <Property.contracts>
export const formatContractType = contracts => {
	const type = getPropertyType(contracts)
	let typeFormatted = null

	switch (type) {
		case 'R':
			typeFormatted = 'Affitto'
			break
		case 'TR':
			typeFormatted = 'Affitto turistico'
			break
		case 'R+TR':
			typeFormatted = 'Affitto, Aff. turistico'
			break
		case 'S':
			typeFormatted = 'Vendita'
			break

		default:
			typeFormatted = '???'
			break
	}

	return typeFormatted
}

const getPropertyType = contracts => {
	const guids = getRealEstateGUIDs()

	const sale = contracts.filter(x => x.type.id === guids.sale).length > 0
	const rent = contracts.filter(x => x.type.id === guids.rent).length > 0
	const touristRental = contracts.filter(x => x.type.id === guids.touristRental).length > 0

	let type = null
	switch (true) {
		case touristRental && !rent && !sale:
			type = 'TR'
			break
		case !touristRental && rent && !sale:
			type = 'R'
			break
		case touristRental && rent && !sale:
			type = 'R+TR'
			break
		case !touristRental && !rent && sale:
			type = 'S'
			break

		default:
			type = '?'
			break
	}

	return type
}

export const formatPropertyPrice = rawText => {
  if (!rawText) {
    return 'Contattaci per il prezzo'
  }

	let text = null

	// Making the price <strong>, decimals <small>
	const regex = /(([0-9.]+)(,[0-9]+)? €)/gm
	const subst = `<strong>$2<small>$3</small> €</strong>`
	text = rawText.replace(regex, subst)
	text = text.replace('<small></small>', '')

	// Adding a <br> after "a partire da"
	if (text?.includes('a partire da ')) {
		text = text.replace('a partire da ', 'a partire da<br>')
	}

	return text
}

// Converts the API returned image url into case.asiago.it url
export const convertPropertyImageUrl = originalUrl => {
	const regex =
		/^https:\/\/api\.webcloud\.it\/v\d+\/realestate\/images\/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})\/([a-z]+)\/(.*?)\.(\w+)$/i
	const subst = `https://case.asiago.it/images/realestate/v0/$1/$2/$3.$4`

	return regex.test(originalUrl) ? originalUrl.replace(regex, subst) : originalUrl
}
